import { render, staticRenderFns } from "./admin-admin.vue?vue&type=template&id=b392170c"
import script from "./admin-admin.vue?vue&type=script&lang=js"
export * from "./admin-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports